import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const loggedInUser = localStorage.getItem("loggedInUser");
  const userRole = localStorage.getItem("userRole");

  let token = null;

  try {
    const parsedUser = JSON.parse(loggedInUser);
    token = parsedUser?.data?.token;
  } catch (err) {
    token = null;
  }

  // Not logged in
  if (!token) {
    localStorage.clear();
    return <Navigate to="/login" replace />;
  }

  // Wrong role
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;